import { useLogger } from '@capsicum/common';
import { type FeedTypes } from '@capsicum/socios-core';
import { useCallback } from 'react';

import { useRemoveActivityFromFeed } from '../useRemoveActivityFromFeed';

type ErrorBoundaryPostWrapperProps = {
	activityId: string;
	feedType: FeedTypes;
};

export const useErrorBoundaryPostWrapper = ({ activityId, feedType }: ErrorBoundaryPostWrapperProps) => {
	const { removeActivity } = useRemoveActivityFromFeed([feedType]);
	const logger = useLogger();

	const handleOnError = useCallback(
		(error: Error) => {
			logger.error(`Error while rendering post with activityId: ${activityId}`, error);

			removeActivity(activityId);
		},
		[activityId, logger, removeActivity]
	);

	return {
		handleOnError
	};
};
